module.exports = __webpack_public_path__ + "img/icon-Contact-address@2x.985c2fdb.png";